import { NgClass, NgStyle } from '@angular/common';
import { Component, input } from '@angular/core';
import { ClientStatus } from '@models';

@Component({
  imports: [NgStyle, NgClass],
  selector: 'avs-client-status',
  standalone: true,
  styleUrl: './client-status.component.scss',
  template: ` <span
    class="inline-block font-semibold	capitalize px-2 py-0.5 rounded-md"
    [ngStyle]="{ 'font-size': fontSize() }"
    [ngClass]="{
      'status-active': status() === eClientStatus.ACTIVE,
      'status-inactive': status() === eClientStatus.INACTIVE,
      'status-invited': status() === eClientStatus.INVITED,
      'status-blocked': status() === eClientStatus.BLOCKED,
      'status-archived': status() === eClientStatus.ARCHIVED,
      'status-deactivated': status() === eClientStatus.DEACTIVATED,
    }"
    >{{ status() }}</span
  >`,
})
export class ClientStatusComponent {
  status = input<ClientStatus>(ClientStatus.ACTIVE);
  fontSize = input('0.75rem');
  protected readonly eClientStatus = ClientStatus;
}
